/* octipa: camada interativa das secoes clonadas (o scope remove os <script> do concorrente).
   Carrosseis = scroll nativo com [data-track] (toque/swipe nativo) + setas; abas dos depoimentos;
   swatch de cor dos cards. */
(function(){
  if (window.__clOct) return; window.__clOct = true;
  var ARROWS = '.rp-arrow,.rp-cat-arrow,.rp-testi-arrow,[data-cl-arrow]';
  function rootOf(el){ return el.closest('[class*="cl-sec-"]') || el.closest('section') || document; }
  function trackOf(root){ return root.querySelector('[data-track]'); }
  function step(grid){
    var kids = [].filter.call(grid.children, function(c){ return !c.hidden && c.offsetWidth; });
    var c = kids[0]; if (!c) return 320;
    var cs = getComputedStyle(grid);
    return c.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 0);
  }
  function sync(root){
    var grid = trackOf(root); if (!grid) return;
    root.querySelectorAll(ARROWS).forEach(function(b){
      var next = b.getAttribute('data-dir') === 'next';
      b.disabled = next ? grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2 : grid.scrollLeft <= 2;
    });
  }
  document.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    var b = t.closest(ARROWS);
    if (b) {
      var root = rootOf(b), grid = trackOf(root); if (!grid) return;
      e.preventDefault();
      grid.scrollBy({left: (b.getAttribute('data-dir') === 'next' ? 1 : -1) * step(grid), behavior: 'smooth'});
      return;
    }
    var tab = t.closest('.rp-tf');
    if (tab) {
      var r = rootOf(tab), cat = tab.getAttribute('data-cat');
      r.querySelectorAll('.rp-tf').forEach(function(x){ x.classList.toggle('is-active', x === tab); });
      r.querySelectorAll('.rp-testi-card').forEach(function(c){ c.hidden = c.getAttribute('data-cat') !== cat; });
      var g = trackOf(r); if (g) g.scrollLeft = 0;
      sync(r); return;
    }
    var sw = t.closest('.card-colorswatch');
    if (sw) {
      e.preventDefault(); e.stopPropagation();
      var wrap = sw.closest('[class*="card-wrapper"]'); if (!wrap) return;
      var img = wrap.querySelector('[class*="card__media"] img'), src = sw.getAttribute('data-variant-img');
      if (img && src) { img.setAttribute('srcset', ''); img.setAttribute('src', src); }
      wrap.querySelectorAll('.card-colorswatch').forEach(function(s){ s.classList.remove('is-active'); });
      sw.classList.add('is-active');
    }
  }, true);
  function init(){
    document.querySelectorAll('[data-track]').forEach(function(grid){
      var root = rootOf(grid);
      grid.addEventListener('scroll', function(){ sync(root); }, {passive: true});
      /* arraste com o mouse (desktop); o toque ja e nativo pelo overflow-x */
      var down = false, sx = 0, sl = 0, moved = false;
      grid.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = grid.scrollLeft; });
      window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) moved = true; grid.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function(){ down = false; });
      grid.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      sync(root);
    });
    /* testemunhos: estado inicial = aba ativa */
    document.querySelectorAll('.rp-tf.is-active').forEach(function(tab){
      var r = rootOf(tab), cat = tab.getAttribute('data-cat');
      r.querySelectorAll('.rp-testi-card').forEach(function(c){ c.hidden = c.getAttribute('data-cat') !== cat; });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* octipa: sliders Dawn, contagem regressiva, rotadores e filtros da colecao */
(function(){
  if (window.__clOct2) return; window.__clOct2 = true;
  function ready(f){ if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }
  ready(function(){
    /* 1. slider-component do Dawn (ul overflow + botoes + contador) */
    document.querySelectorAll('cl-slider-component, slider-component').forEach(function(sc){
      var ul = sc.querySelector('ul'); if (!ul) return;
      var prev = sc.querySelector('[name="previous"]'), next = sc.querySelector('[name="next"]');
      var cur = sc.querySelector('.slider-counter--current'), tot = sc.querySelector('.slider-counter--total');
      function items(){ return [].filter.call(ul.children, function(li){ return li.offsetWidth > 0; }); }
      function stepW(){ var it = items(); return it.length ? it[0].offsetWidth + (parseFloat(getComputedStyle(ul).columnGap) || 0) : 0; }
      function sync(){
        var w = stepW(); if (!w) return;
        var per = Math.max(1, Math.round(ul.clientWidth / w));
        var total = Math.max(1, items().length - per + 1), idx = Math.round(ul.scrollLeft / w) + 1;
        if (cur) cur.textContent = Math.min(idx, total);
        if (tot) tot.textContent = total;
        if (prev) prev.disabled = ul.scrollLeft <= 2;
        if (next) next.disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 2;
      }
      function go(dir){ ul.scrollBy({left: dir * stepW(), behavior: 'smooth'}); }
      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); go(-1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); go(1); });
      ul.addEventListener('scroll', sync, {passive: true});
      window.addEventListener('resize', sync);
      sync();
    });
    /* 2. contagem regressiva (FRENCH DAYS) */
    document.querySelectorAll('.se26-units[data-enddate]').forEach(function(u){
      var end = new Date(u.getAttribute('data-enddate').replace(' ', 'T') + ':00+02:00').getTime();
      if (isNaN(end)) return;
      function p(n){ return (n < 10 ? '0' : '') + n; }
      function tick(){
        var t = Math.max(0, end - Date.now()), e;
        if ((e = u.querySelector('[data-d]'))) e.textContent = p(Math.floor(t / 864e5));
        if ((e = u.querySelector('[data-h]'))) e.textContent = p(Math.floor(t % 864e5 / 36e5));
        if ((e = u.querySelector('[data-m]'))) e.textContent = p(Math.floor(t % 36e5 / 6e4));
        if ((e = u.querySelector('[data-s]'))) e.textContent = p(Math.floor(t % 6e4 / 1e3));
      }
      tick(); setInterval(tick, 1000);
    });
    /* 3. rotador de nivel de fluxo (2s) */
    document.querySelectorAll('.information-flux-2__container').forEach(function(c){
      var g = ['.flux-title', '.flux-drops', '.flux-2-equivalence__container'].map(function(s){ return c.querySelectorAll(s); });
      if (!g[0].length) return;
      var i = 0;
      setInterval(function(){
        i = (i + 1) % g[0].length;
        g.forEach(function(list){ list.forEach(function(el, k){ el.classList.toggle('clx-hidden', k !== i); }); });
      }, 2000);
    });
    /* 4. faixa de texto rotativa (slick do concorrente): autoplay 2s + swipe */
    document.querySelectorAll('.swiper-slider').forEach(function(s){
      var list = s.querySelector('.slick-list'), track = s.querySelector('.slick-track');
      if (!list || !track) return;
      track.querySelectorAll('.slick-cloned').forEach(function(c){ c.remove(); });
      var slides = [].slice.call(track.querySelectorAll('.slick-slide'));
      if (slides.length < 2) return;
      var i = 0;
      slides.forEach(function(sl, k){ if (sl.classList.contains('slick-current')) i = k; });
      function lay(anim){
        var w = list.clientWidth;
        slides.forEach(function(sl){ sl.style.width = w + 'px'; });
        track.style.width = (w * slides.length) + 'px';
        track.style.transition = anim ? 'transform .5s ease' : 'none';
        track.style.transform = 'translate3d(' + (-i * w) + 'px,0,0)';
      }
      function go(d){ i = (i + d + slides.length) % slides.length; lay(true); }
      lay(false);
      window.addEventListener('resize', function(){ lay(false); });
      var timer = setInterval(function(){ go(1); }, 2000), x0 = null;
      list.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; clearInterval(timer); }, {passive: true});
      list.addEventListener('touchend', function(e){
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 30) go(dx < 0 ? 1 : -1);
        timer = setInterval(function(){ go(1); }, 2000);
      });
    });
    /* 5. "voir plus" da descricao da colecao */
    document.querySelectorAll('.btn_toggle').forEach(function(b){
      var span = b.parentElement;
      if (!span) return;
      b.addEventListener('click', function(){
        var ex = span.classList.toggle('expanded');
        var l = b.querySelector('.label_read'), d = b.querySelector('.clx-dot');
        if (l) l.textContent = ex ? ' voir moins' : 'voir plus';
        if (d) d.style.display = ex ? 'none' : '';
      });
    });
    /* 6. ordenacao real (sort_by da Shopify) */
    document.querySelectorAll('select[name="sort_by"]').forEach(function(sel){
      sel.addEventListener('change', function(){
        var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); location.href = u.toString();
      });
    });
    /* 7. filtros da grade (fluxo / tamanho / preco) no cliente, com contagens reais */
    var grid = document.getElementById('product-grid');
    var form = document.getElementById('FacetFiltersForm');
    if (grid && form) {
      var cards = [].filter.call(grid.children, function(li){ return li.hasAttribute('data-flux'); });
      var deco = [].filter.call(grid.children, function(li){ return !li.hasAttribute('data-flux'); });
      var label = function(inp){
        var lab = inp.closest('label'), sp = lab && lab.querySelector('span[aria-hidden]');
        return sp ? sp.textContent.replace(/\(\d+\)/, '').trim() : '';
      };
      var valOf = function(inp){ return inp.name.indexOf('taille') >= 0 ? label(inp) : inp.value; };
      var match = function(li, name, val){
        if (name.indexOf('flux') >= 0) return (li.getAttribute('data-flux') || '').trim() === val;
        if (name.indexOf('taille') >= 0) return (li.getAttribute('data-sizes') || '').indexOf('|' + val) >= 0;
        return true;
      };
      form.querySelectorAll('input[type=checkbox]').forEach(function(inp){
        var v = valOf(inp);
        var n = cards.filter(function(li){ return match(li, inp.name, v); }).length;
        var lab = inp.closest('label');
        if (!lab) return;
        lab.querySelectorAll('span').forEach(function(sp){
          [].forEach.call(sp.childNodes, function(nd){
            if (nd.nodeType === 3 && /\(\d+/.test(nd.textContent)) nd.textContent = nd.textContent.replace(/\(\d+/, '(' + n);
          });
        });
        var li = lab.closest('li');
        if (li && !n) li.style.display = 'none';
      });
      var apply = function(){
        var groups = {};
        form.querySelectorAll('input[type=checkbox]:checked').forEach(function(inp){
          (groups[inp.name] = groups[inp.name] || []).push(valOf(inp));
        });
        var gI = form.querySelector('[name="filter.v.price.gte"]'), lI = form.querySelector('[name="filter.v.price.lte"]');
        var gte = gI && gI.value !== '' ? parseFloat(gI.value) : 0;
        var lte = lI && lI.value !== '' ? parseFloat(lI.value) : Infinity;
        var any = Object.keys(groups).length || gte > 0 || lte < Infinity, shown = 0;
        cards.forEach(function(li){
          var ok = Object.keys(groups).every(function(n){ return groups[n].some(function(v){ return match(li, n, v); }); });
          var pr = (+li.getAttribute('data-price') || 0) / 100;
          ok = ok && pr >= gte && pr <= lte;
          li.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        deco.forEach(function(li){ li.style.display = any ? 'none' : ''; });
        document.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach(function(e){
          e.innerHTML = shown + '&nbsp;produit' + (shown === 1 ? '' : 's');
        });
      };
      form.addEventListener('change', apply);
      form.addEventListener('submit', function(e){ e.preventDefault(); apply(); });
      form.querySelectorAll('input[type=number]').forEach(function(i){ i.addEventListener('input', apply); });
    }
  });
})();

/* octipa: PDP (galeria, kits Moonbundle, ATC, faixa de servicos, stories, guia de tamanhos) */
(function(){
  if (window.__clOct3) return; window.__clOct3 = true;
  function ready(f){ if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }
  ready(function(){
    document.querySelectorAll('.cl-pdp-full').forEach(function(root){
      var V = [];
      try { V = JSON.parse(root.querySelector('[data-cl-variants]').textContent); } catch (e) {}
      /* ---- galeria: miniatura -> item ativo ---- */
      var list = root.querySelector('.clx-product__media-list');
      function show(mediaId){
        if (!list) return;
        var items = list.querySelectorAll('.clx-product__media-item'), hit = null;
        items.forEach(function(li){ var on = (li.getAttribute('data-media-id') || '').split('-').pop() === String(mediaId); li.classList.toggle('clx-is-active', on); if (on) hit = li; });
        if (!hit && items[0]) { items[0].classList.add('clx-is-active'); hit = items[0]; }
        if (hit && window.innerWidth < 750) list.scrollTo({left: hit.offsetLeft - list.offsetLeft, behavior: 'smooth'});
        root.querySelectorAll('.clx-thumbnail-list__item').forEach(function(t){
          var b = t.querySelector('button'); var on = (t.getAttribute('data-target') || '').split('-').pop() === String(mediaId);
          if (b) { if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
        });
      }
      root.querySelectorAll('.clx-thumbnail-list__item').forEach(function(t){
        t.addEventListener('click', function(e){ e.preventDefault(); show((t.getAttribute('data-target') || '').split('-').pop()); });
      });
      /* ---- kits (Moonbundle) ---- */
      var wrappers = [].slice.call(root.querySelectorAll('.moonbundle-option-wrapper'));
      function activeWrap(){ return wrappers.filter(function(w){ return w.querySelector('.moonbundle-option-active'); })[0] || wrappers[0]; }
      wrappers.forEach(function(w){
        var opt = w.querySelector('.moonbundle-option'); if (!opt) return;
        opt.addEventListener('click', function(e){
          if (e.target.closest('select')) return;
          wrappers.forEach(function(x){ var o = x.querySelector('.moonbundle-option'); var on = x === w;
            if (o) o.classList.toggle('moonbundle-option-active', on);
            var r = x.querySelector('input[type=radio]'); if (r) r.checked = on; });
        });
      });
      function variantFor(row){
        var vals = [].map.call(row.querySelectorAll('select[data-cl-opt]'), function(s){ return s.value; });
        return V.filter(function(v){ return vals.every(function(val, i){ return v.options[i] === val; }); })[0];
      }
      /* troca a foto pela cor escolhida na 1a linha */
      var COLORS = {}; try { COLORS = JSON.parse(root.querySelector('[data-cl-colors]').textContent); } catch (e) {}
      root.addEventListener('change', function(e){
        if (e.target.classList.contains('cl-dd-native')) {
          var dd = e.target.parentNode, lab = dd.querySelector('.moonbundle-dropdown-selected span'), sw = dd.querySelector('.moonbundle-swatch-indicator');
          if (lab) lab.textContent = e.target.value;
          if (sw) sw.style.backgroundColor = COLORS[e.target.value] || '#cccccc';
        }
        var row = e.target.closest('.moonbundle-variant-row'); if (!row) return;
        var v = variantFor(row);
        if (v && v.featured_media && row.id === 'moonbundle-variant-row-1') {
          var fid = String(v.featured_media.id);
          root.querySelectorAll('[data-cl-vm]').forEach(function(el){ el.classList.toggle('cl-vhide', el.getAttribute('data-cl-vm') !== fid); });
          show(fid);
        }
        var f = root.querySelector('form[data-cl-bundle]');
        if (v && f) f.querySelectorAll('input[name=id]').forEach(function(i){ i.value = v.id; });
      });
      /* ---- ATC: N unidades do kit ativo ---- */
      var form = root.querySelector('form[data-cl-bundle]');
      if (form) form.addEventListener('submit', function(e){
        e.preventDefault(); e.stopPropagation();
        var w = activeWrap(), scope = w || root.querySelector('.cl-nokit') || root;
        var rows = scope ? scope.querySelectorAll('.moonbundle-variant-row') : [];
        var items = {};
        if (rows.length) {
          rows.forEach(function(r){ var v = variantFor(r); if (v) items[v.id] = (items[v.id] || 0) + 1; });
        } else {
          var qty = w ? +(w.getAttribute('data-cl-qty') || 1) : 1;
          var id = (form.querySelector('input[name=id]') || {}).value;
          if (id) items[id] = qty;
        }
        var payload = {items: Object.keys(items).map(function(k){ return {id: +k, quantity: items[k]}; })};
        if (!payload.items.length) return;
        var btn = form.querySelector('[type=submit]'); if (btn) btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(payload)})
          .then(function(r){ if (!r.ok) throw r; return r.json(); })
          .then(function(){ if (btn) btn.removeAttribute('aria-busy'); document.dispatchEvent(new CustomEvent('cl:cart:open')); })
          .catch(function(){ if (btn) btn.removeAttribute('aria-busy'); document.dispatchEvent(new CustomEvent('cl:cart:open')); });
      }, true);
      /* ---- faixa de servicos (auto slide 3s + pontos) ---- */
      var sc = root.querySelector('.slider-content');
      if (sc) {
        var n = sc.children.length, i = 0, dots = root.querySelectorAll('.clx-pagination .clx-dot');
        var go = function(k){ i = (k + n) % n; sc.style.transform = 'translateX(' + (-100 * i) + '%)';
          dots.forEach(function(d, j){ d.classList.toggle('active', j === i); }); };
        dots.forEach(function(d, j){ d.removeAttribute('onclick'); d.addEventListener('click', function(){ go(j); }); });
        var m = /translateX\((-?\d+)%\)/.exec(sc.style.transform || ''); go(m ? -(+m[1]) / 100 : 0);
        setInterval(function(){ go(i + 1); }, 3000);
        var x0 = null;
        sc.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive: true});
        sc.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 30) go(i + (dx < 0 ? 1 : -1)); });
      }
      /* ---- stories ---- */
      var ov = root.querySelector('[data-cl-story-ov]');
      if (ov) {
        var vids = (ov.getAttribute('data-videos') || '').split(','), cur = 0, video = ov.querySelector('video');
        var play = function(k){ cur = (k + vids.length) % vids.length; video.src = vids[cur]; video.play().catch(function(){}); };
        root.querySelectorAll('[data-cl-story]').forEach(function(b){ b.addEventListener('click', function(){
          ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; play(+b.getAttribute('data-cl-story')); }); });
        var close = function(){ ov.classList.remove('is-open'); video.pause(); document.body.style.overflow = ''; };
        ov.querySelector('.x').addEventListener('click', close);
        ov.querySelector('.p').addEventListener('click', function(){ play(cur - 1); });
        ov.querySelector('.n').addEventListener('click', function(){ play(cur + 1); });
        video.addEventListener('ended', function(){ if (cur < vids.length - 1) play(cur + 1); else close(); });
        ov.addEventListener('click', function(e){ if (e.target === ov) close(); });
      }
      /* ---- guia de tamanhos ---- */
      var so = root.querySelector('[data-cl-size-ov]');
      root.querySelectorAll('[data-cl-size] button').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); if (so) so.classList.add('is-open'); }); });
      if (so) { so.querySelector('.x').addEventListener('click', function(){ so.classList.remove('is-open'); });
        so.addEventListener('click', function(e){ if (e.target === so) so.classList.remove('is-open'); }); }
    });
  });
})();

/* octipa: retrabalho das PDPs (2026-09-28)
   1. guia de tamanhos: o botao copiado do Kiwi (.ks-chart-modal-button) abre o modal
      snippets/cl-size-guide.liquid (chart do Kiwi por produto).
   2. sliders da PDP (galeria, miniaturas, reviews do buybox, secao de reviews): setas,
      arraste de mouse no desktop e swipe de toque no mobile (scroll nativo do trilho). */
(function(){
  if (window.__clOct4) return; window.__clOct4 = true;
  function ready(f){ if (document.readyState !== 'loading') f(); else document.addEventListener('DOMContentLoaded', f); }

  /* ---------------- 1. guia de tamanhos ---------------- */
  function modal(){ return document.querySelector('[data-cl-sg-modal]'); }
  function openSG(){
    var m = modal(); if (!m) return;
    /* fora de qualquer ancestral com transform/overflow: position:fixed precisa do viewport */
    if (m.parentNode !== document.body) document.body.appendChild(m);
    m.hidden = false; m.classList.add('is-open'); m.scrollTop = 0;
    document.documentElement.classList.add('cl-sg-lock');
    var x = m.querySelector('[data-cl-sg-close]'); if (x) x.focus({preventScroll: true});
  }
  function closeSG(){
    var m = modal(); if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open'); m.hidden = true;
    document.documentElement.classList.remove('cl-sg-lock');
  }
  document.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.ks-chart-modal-button, .sizing-chart-modal-button, [data-cl-size-open]')) {
      e.preventDefault(); e.stopPropagation(); openSG(); return;
    }
    var m = t.closest('[data-cl-sg-modal]');
    if (m && (t === m || t.closest('[data-cl-sg-close]'))) { e.preventDefault(); closeSG(); }
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSG(); });

  /* ---------------- 2. sliders ---------------- */
  var SLIDERS = [
    /* trilho, raiz, seta anterior, seta seguinte (setas null = ja tratadas pelo cl-slider-component) */
    {track: '.clx-product__media-list', root: 'cl-slider-component', prev: null, next: null},
    {track: '.clx-thumbnail-list', root: 'cl-slider-component', prev: null, next: null},
    {track: '.oct-reviews__track', root: '.oct-reviews', prev: '.oct-reviews__nav--prev', next: '.oct-reviews__nav--next'},
    {track: '.octipa-reviews__slider', root: '.octipa-reviews', prev: '[data-octipa-prev]', next: '[data-octipa-next]'}
  ];
  function kids(tr){ return [].filter.call(tr.children, function(c){ return c.offsetWidth > 0; }); }
  function step(tr){
    var k = kids(tr); if (!k.length) return tr.clientWidth;
    var gap = parseFloat(getComputedStyle(tr).columnGap) || 0;
    if (k.length > 1) gap = Math.max(gap, k[1].getBoundingClientRect().left - k[0].getBoundingClientRect().right);
    return k[0].getBoundingClientRect().width + gap;
  }
  function nearest(tr){
    /* posicao do filho mais proximo do scrollLeft atual (para assentar depois do arraste) */
    var base = tr.getBoundingClientRect().left + (parseFloat(getComputedStyle(tr).paddingLeft) || 0), best = tr.scrollLeft, d = 1e9;
    kids(tr).forEach(function(c){
      var pos = tr.scrollLeft + c.getBoundingClientRect().left - base;
      if (Math.abs(pos - tr.scrollLeft) < d) { d = Math.abs(pos - tr.scrollLeft); best = pos; }
    });
    return Math.max(0, Math.min(best, tr.scrollWidth - tr.clientWidth));
  }
  function wire(cfg, tr){
    if (tr.__clSl) return; tr.__clSl = true;
    var root = tr.closest(cfg.root) || tr.parentElement;
    var prev = cfg.prev && root.querySelector(cfg.prev), next = cfg.next && root.querySelector(cfg.next);
    function sync(){
      var max = tr.scrollWidth - tr.clientWidth;
      if (prev) { prev.disabled = tr.scrollLeft <= 2; prev.setAttribute('aria-disabled', prev.disabled); }
      if (next) { next.disabled = tr.scrollLeft >= max - 2; next.setAttribute('aria-disabled', next.disabled); }
    }
    function go(dir){ tr.scrollBy({left: dir * step(tr), behavior: 'smooth'}); }
    /* setas: o onclick do tema dele nao existe aqui */
    [prev, next].forEach(function(b, i){
      if (!b) return;
      b.removeAttribute('onclick');
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(i ? 1 : -1); });
    });
    tr.addEventListener('scroll', sync, {passive: true});
    window.addEventListener('resize', sync);
    /* toque: scroll nativo do trilho (overflow-x:auto + snap); garantir que nada o bloqueie */
    tr.style.touchAction = 'pan-x pan-y';
    tr.style.webkitOverflowScrolling = 'touch';
    tr.style.overscrollBehaviorX = 'contain';
    /* arraste com o mouse (desktop) */
    var down = false, sx = 0, sl = 0, moved = false, snap = '';
    tr.addEventListener('dragstart', function(e){ e.preventDefault(); });
    tr.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse' || e.button !== 0 || tr.scrollWidth <= tr.clientWidth + 2) return;
      down = true; moved = false; sx = e.clientX; sl = tr.scrollLeft;
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) {
        moved = true; snap = tr.style.scrollSnapType; tr.style.scrollSnapType = 'none';
        tr.style.scrollBehavior = 'auto'; tr.style.cursor = 'grabbing'; tr.style.userSelect = 'none';
      }
      if (moved) { tr.scrollLeft = sl - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function(){
      if (!down) return; down = false;
      if (!moved) return;
      tr.style.cursor = ''; tr.style.userSelect = '';
      /* sem snap: assenta no filho mais proximo, na direcao do arraste */
      var target = nearest(tr), s = step(tr);
      if (Math.abs(tr.scrollLeft - sl) > 30 && Math.abs(target - sl) < 2) target = sl + (tr.scrollLeft > sl ? s : -s);
      tr.scrollTo({left: Math.max(0, Math.min(target, tr.scrollWidth - tr.clientWidth)), behavior: 'smooth'});
      setTimeout(function(){ tr.style.scrollSnapType = snap; tr.style.scrollBehavior = ''; }, 450);
      setTimeout(function(){ moved = false; }, 80);
    });
    /* o clique que termina um arraste nao abre/seleciona nada */
    tr.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    sync();
  }
  function boot(){
    SLIDERS.forEach(function(cfg){
      document.querySelectorAll(cfg.track).forEach(function(tr){ wire(cfg, tr); });
    });
    /* galeria no mobile: o swipe no trilho principal marca a miniatura correspondente */
    document.querySelectorAll('.clx-product__media-list').forEach(function(ml){
      var root = ml.closest('.cl-pdp-full') || document, t = null;
      ml.addEventListener('scroll', function(){
        clearTimeout(t);
        t = setTimeout(function(){
          var items = kids(ml), base = ml.getBoundingClientRect().left, hit = null, d = 1e9;
          items.forEach(function(li){ var x = Math.abs(li.getBoundingClientRect().left - base); if (x < d) { d = x; hit = li; } });
          if (!hit) return;
          items.forEach(function(li){ li.classList.toggle('clx-is-active', li === hit); });
          var id = (hit.getAttribute('data-media-id') || '').split('-').pop();
          root.querySelectorAll('.clx-thumbnail-list__item').forEach(function(th){
            var on = (th.getAttribute('data-target') || '').split('-').pop() === id, b = th.querySelector('button');
            if (b) { if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
          });
        }, 120);
      }, {passive: true});
    });
  }
  ready(boot);

  /* ---------------- 3. slot de apps (Moonbundle removido, 2026-09-28) ----------------
     Os blocos irmaos do buybox copiado no main-product (variant_picker nativo, Kaching
     Bundles e qualquer bloco de app que o operador inserir) entram no [data-cl-app-slot],
     no lugar onde ficava o app do concorrente, na ordem do editor. */
  function fillSlot(root){
    var slot = root.querySelector('[data-cl-app-slot]'); if (!slot) return;
    var host = root; while (host.parentElement && !host.parentElement.classList.contains('product__info-container')) host = host.parentElement;
    var box = host.parentElement; if (!box) return;
    function fill(){
      [].slice.call(box.children).forEach(function(el){
        if (el === host || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
        slot.appendChild(el);
      });
    }
    fill();
    if (window.MutationObserver) new MutationObserver(fill).observe(box, {childList: true});
  }
  /* troca de variante no seletor nativo: a foto da variante vai para a frente */
  function variantPhotos(root){
    var V = []; try { V = JSON.parse(root.querySelector('[data-cl-variants]').textContent); } catch (e) {}
    var slot = root.querySelector('[data-cl-app-slot]'); if (!slot || !V.length) return;
    slot.addEventListener('change', function(){
      setTimeout(function(){
        var form = root.querySelector('form[action*="/cart/add"]'), inp = form && form.querySelector('input[name=id]');
        var v = inp && V.filter(function(x){ return String(x.id) === String(inp.value); })[0];
        if (!v || !v.featured_media) return;
        var fid = String(v.featured_media.id);
        root.querySelectorAll('[data-cl-vm]').forEach(function(el){ el.classList.toggle('cl-vhide', el.getAttribute('data-cl-vm') !== fid); });
        var th = [].filter.call(root.querySelectorAll('.clx-thumbnail-list__item'), function(t){ return (t.getAttribute('data-target') || '').split('-').pop() === fid; })[0];
        if (th) th.click();
      }, 60);
    });
  }
  ready(function(){ document.querySelectorAll('.cl-pdp-full').forEach(function(r){ fillSlot(r); variantPhotos(r); }); });
})();
